import { ExteriorDamage } from './ExteriorDamage';
import { ExteriorLevel3 } from './ExteriorGeneral';
import { FitFinishFrame } from './FitFinishFrame';
import { Tires } from './Tires';

export const Exterior = () => {
  return (
    <>
      <ExteriorLevel3 />
      <Tires />
      <FitFinishFrame />
      <ExteriorDamage />
    </>
  );
};
